import { render, staticRenderFns } from "./RecaptchaBadge.vue?vue&type=template&id=2f647e46"
import script from "./RecaptchaBadge.vue?vue&type=script&lang=js"
export * from "./RecaptchaBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports